type IProps = {
  isNext?: boolean;
  now: Date;
};

export function getDatesBetween(startDateStr: string, endDateStr: string) {
  // 날짜 문자열을 Date 객체로 변환 (yyyy-mm-dd 형식)

  const startDate =
    startDateStr < endDateStr ? new Date(startDateStr) : new Date(endDateStr);
  const endDate =
    endDateStr > startDateStr ? new Date(endDateStr) : new Date(startDateStr);

  const dates = [];
  let currentDate = startDate;

  // 시작 날짜부터 끝 날짜까지 반복
  while (currentDate <= endDate) {
    // 날짜 배열에 추가 (YYYY-MM-DD 형식)

    dates.push(currentDate.toISOString().split("T")[0].replaceAll("-", ""));
    currentDate.setDate(currentDate.getDate() + 1); // 하루씩 증가
  }

  return dates;
}

export const afterDay = (diff: number) => {
  const now = new Date().toISOString();
  const year = new Date().getFullYear();
  const month = new Date().getMonth();
  const day = new Date().getDate();

  let sDt = now.split("T")[0].replaceAll("-", "");
  let eDt = new Date(year, month, day + diff)
    .toISOString()
    .split("T")[0]
    .replaceAll("-", "");

  return {
    sDt,
    eDt,
    // sDt: sDt?.replace(/^(\d{0,4})(\d{0,2})(\d{0,2})$/g, `$1${"-"}$2${"-"}$3`),
    // eDt: eDt?.replace(/^(\d{0,4})(\d{0,2})(\d{0,2})$/g, `$1${"-"}$2${"-"}$3`),
  };
};
